import CityPageTemplate from './CityPageTemplate';

export default function ApopkaPage() {
  return (
    <CityPageTemplate
      city="Apopka"
      county="Orange"
      slug="apopka"
      zipCodes={['32703', '32712']}
      neighborhoods={['Downtown Apopka', 'Rock Springs Ridge', 'Errol Estate', 'Kelly Park', 'Piedmont Lakes']}
      localContext="From Rock Springs Ridge to the Apopka Amphitheater area, we serve Apopka families and businesses with the same excellence we bring to every room."
      metaDescription="Professional residential and commercial cleaning services in Apopka, FL. Serving ZIP codes 32703 & 32712. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
